<template>
  <md-dialog
      class="successDialog"
      :md-active.sync="options.showSuccess"
  >
    <!-- TOP SUCCESS BOX -->
    <div class="success-box">
      <div class="success-left">
        <img src="@/assets/images/icons/check.svg" class="success-icon" />
        <span class="success-text" :class="{ 'no-id': !options.showSuccessTripId }" >
          {{ options.successMsg }}
        </span>
      </div>
      <!-- Trip ID block -->
      <NezasaIdBox v-if="options.showSuccessTripId" :tripid="options.showSuccessTripId" />
    </div>

    <!-- ACTION BUTTONS -->
    <md-dialog-actions class="actions">
      <md-button class="md-raised secondary" @click="closeDialog">
        <strong>{{ options.Lang.close_window }}</strong>
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import NezasaIdBox from '@/components/parts/NezasaIdBox.vue';
export default {
  name: "SuccessDialog",
  components: {
    NezasaIdBox,
  },
  props: {
    options: { type: Object, required: true },
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
    },
    closeDialog() {
      this.options.showSuccess = false;
      this.options.successMsg = this.options.Lang && this.options.Lang.Erfolgreich
        ? this.options.Lang.Erfolgreich
        : (this.options.successMsgOld !== '' ? this.options.successMsgOld : this.options.successMsg);
      this.options.showSuccessTripId = null;
    }
  }
};
</script>

<style scoped>
.successDialog {
  max-width: 900px !important;
  width: 900px !important;
  margin: auto;
  border-radius: 12px;
}

/* TOP BOX */
.success-box {
  background: #F1FEE7;
  padding: 40px 50px;
  padding-top: 57px;
  padding-bottom: 63px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px 12px 0 0;
}

/* LEFT SIDE */
.success-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.success-icon {
  width: 38px;
  height: 38px;
}

.success-text {
  font-size: 26px;
  font-weight: 500;
  width: 72%;
  line-height: 1; /* or 1.6 for more space */
}
.success-text.no-id {
  width: auto !important;
}
/* TRIP ID BOX */
.trip-box {
  background: #EAF0DA;
}

/* ACTION BUTTON ROW */
.actions {
  display: flex;
  justify-content: center;
  padding: 35px 0 45px;
  border-top: 1px solid #e8e8e8;
}
</style>
